import React from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { InputText } from '../../ui';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import { connect } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';

interface Props extends SimpleDialogProps {
  onSaveAs: (name: string) => void;
  namesNotAllowed: string[];
}

const SaveTableSettingsDialog: React.FC<Props> = ({ onSaveAs, namesNotAllowed, ...rest }) => {
  const { t, i18n } = useTranslation();
  const [name, setName] = React.useState<string>('');

  const isNotAllowed = namesNotAllowed.includes(name.trim().toLowerCase());

  const title = (
    <div>
      <h2>{t('Save as')}</h2>
      <Trans i18nKey="saveAsTableView">
        <p className="font-light text-gray-500 mt-1 text-sm">
          Views are saved with <span className="font-medium">table configurations</span>
          <br /> and <span className="font-medium">selected filters</span>
        </p>
      </Trans>
    </div>
  );

  return (
    <SimpleDialog {...rest} title={title} disableOkButton={!name || isNotAllowed} handleOk={() => onSaveAs(name)}>
      <div className="mb-3">
        <InputText
          label={t('Name')}
          value={name}
          onChange={(event) => setName(event.target.value)}
          error={isNotAllowed}
          helperText={t('Name is already in use')}
        />
      </div>
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SaveTableSettingsDialog);
